/* eslint-disable unicorn/filename-case -- TODO rename later */
import { AuthenticationStore, isStoredAccessTokenExpired, refreshAccessToken } from "@istari-frontend/auth";
import axios, { InternalAxiosRequestConfig } from "axios";

import { HttpStatusCodeType } from "../enums";

// ServiceConfig as AxiosRequestConfig.config
interface ServiceConfig {
  url?: string;
}

/**
 * Creates a service abstraction around the AxiosInstance.  It currently only exposes common axios HTTP methods, but this can be expanded in the future.
 * @param {*} configuration: simple object containing just the URL.  Can be made more configurable in the future.
 */
export default function createService(configuration?: ServiceConfig) {
  const instance = axios.create({
    baseURL: configuration?.url,
    timeout: 120000,
    withCredentials: true,
  });

  instance.interceptors.request.use(async (config) => {
    if (!config.withCredentials) {
      return config as InternalAxiosRequestConfig;
    }
    if (isStoredAccessTokenExpired()) {
      await refreshAccessToken();
    }

    // Re-instantiate after the refresh: the store snapshots localStorage on
    // construction, so read the token post-refresh to send the renewed one.
    const accessToken = AuthenticationStore().getAccessToken();

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }

    return config as InternalAxiosRequestConfig;
  });

  instance.interceptors.response.use(
    (response) => response?.data,

    (error) => {
      if (error.response?.status === HttpStatusCodeType.Unauthorized) {
        AuthenticationStore().clearSessionToken();
        window.location.reload();
      }
      return Promise.reject(error);
    },
  );

  return {
    concurrentRequests: axios.all,
    get: instance.get,
    patch: instance.patch,
    post: instance.post,
    put: instance.put,
    remove: instance.delete,
  };
}
